export default "__VITE_ASSET__C2oc1VCu__"